module.exports = __webpack_public_path__ + "media/details/expo@1x-f707604e.png";